const o = {
  normal: "normal",
  regular: "400",
  semibold: "600",
  bold: "700"
};
export {
  o as default
};
